<script setup>
import { useAuthStore } from "@/stores";
import { ElPopover } from "element-plus";
import { computed } from "vue";
import { useWeeklyReportStore } from "@/stores/useWeeklyReportSettings";
import { useRoute } from "vue-router";
import WeeklyReportSettings from "../layout/WeeklyReportSettings.vue";

const route = useRoute();
const weeklyReportStore = useWeeklyReportStore();
const authStore = useAuthStore();
const isSuperAdmin = computed(() => authStore.isSuperAdmin);
const isAccountManager = computed(() => authStore.isAccountManager);
const isMultiStoreManager = computed(() => authStore.isMultiStoreManager);
const routes = [
  {
    name: "Manage Badge",
    to: "/manage/badges",
    urlType: "lms",
  },
  {
    name: "Manage Users",
    to: "/central/manage-users",
    urlType: "central",
  },
  {
    name: "Manage Curriculums",
    to: "/manage/curriculums",
    urlType: "lms",
  },
  {
    name: "Manage Courses",
    to: "/manage/courses",
    urlType: "lms",
  },
  {
    name: "Manage Categories",
    to: "/manage/categories",
    urlType: "lms",
  },
  {
    name: "Manage Playlist",
    to: "/manage/playlist",
    urlType: "lms",
  },
  {
    name: "Manage Companies",
    to: "/central/companies",
    urlType: "central",
  },
  {
    name: "Manage Stores",
    to: "/central/stores",
    urlType: "central",
  },
  {
    name: "Manage Banner",
    to: "/banner",
    urlType: "lms",
  },
  {
    name: "Usage Report",
    to: "/usage-report",
    urlType: "lms",
  },
];

const isExist = computed(() => routes.some((r) => r.to === route.fullPath));

const filteredRoutes = computed(() => {
  return routes.filter((route) => {
    const name = route.name.toLowerCase();

    if (!isSuperAdmin.value && name === "manage badge") {
      return false;
    }

    if (!isSuperAdmin.value && name === "manage companies") {
      return false;
    }

    if (!isSuperAdmin.value && name === "manage banner") {
      return false;
    }

    if (
      !isSuperAdmin.value &&
      !isAccountManager.value &&
      !isMultiStoreManager.value &&
      name === "manage stores"
    ) {
      return false;
    }

    if (
      !isSuperAdmin.value &&
      !isAccountManager.value &&
      name === "manage courses"
    ) {
      return false;
    }

    if (
      !isSuperAdmin.value &&
      !isAccountManager.value &&
      name === "manage playlist"
    ) {
      return false;
    }

    if (!isSuperAdmin.value && name === "manage curriculums") {
      return false;
    }

    if (!isSuperAdmin.value && name === "usage report") {
      return false;
    }

    if (!isSuperAdmin.value && name === "manage categories") {
      return false;
    }

    return true;
  });
});

const handleClickShow = (route) => {
  switch (route.name.toLowerCase()) {
    case "manage weekly report":
      weeklyReportStore.showDialog();
      break;

    default:
      break;
  }
};
</script>
<template>
  <div v-bind="$attrs">
    <slot :filteredRoutes="filteredRoutes">
      <el-popover
        :width="220"
        popper-style="padding: 5px !important;z-index: 3000 !important; background-color: #161616"
      >
        <template #reference>
          <a
            class="px-1 pt-1 text-sm w-full h-full flex justify-center items-center font-medium"
            :class="{
              'text-kintz-primary-2 border-kintz-primary-2 border-b-2': isExist,
              'hover:border-kintz-primary-2 border-b-2 border-transparent hover:text-kintz-primary-2 text-kintz-primary-4':
                !isExist,
            }"
          >
            Admin Portal
          </a>
        </template>
        <template #default>
          <div class="w-full flex flex-col justify-start items-start">
            <div
              class="w-full"
              v-for="(r, index) in filteredRoutes"
              :key="index"
            >
              <router-link
                class="w-full px-2 py-2 text-sm flex justify-start items-start"
                :class="{
                  'text-kintz-primary-2': route.fullPath === r.to,
                  'hover:text-kintz-primary-2 text-kintz-primary-4':
                    route.fullPath !== r.to,
                }"
                :to="r.to"
                v-if="r.urlType === 'lms'"
              >
                {{ r.name }}
              </router-link>
              <a
                :href="r.to"
                v-else-if="r.urlType === 'central'"
                target="_blank"
                class="w-full px-2 py-2 text-sm flex justify-start items-start hover:text-kintz-primary-2 text-kintz-primary-4"
                >{{ r.name }}</a
              >
              <button
                v-else
                class="w-full px-2 py-2 text-sm hover:text-kintz-primary-2 text-kintz-primary-4 flex justify-start items-start"
                @click="handleClickShow(r)"
              >
                {{ r.name }}
              </button>
            </div>
          </div>
        </template>
      </el-popover>
    </slot>
    <WeeklyReportSettings />
  </div>
</template>
<style lang="scss" scoped></style>
